import React from 'react';
import classes from './ExaminationFrames.module.css';
import { mainHostUrl } from '../../helpers';

type Props = {
  index: number;
  attachmentUrl: string;
  selectedFrame: number;
  setSelectedFrame: () => void;
  setSelectedUrl: (srcUrl: string) => void;
};

const FramesListItem: React.FC<Props> = ({
  index,
  attachmentUrl,
  selectedFrame,
  setSelectedFrame,
  setSelectedUrl,
}) => {
  // React.useEffect(() => {
  //   if (attachmentUrl) {
  //     fetch(attachmentUrl).then((response) => {
  //       setSrcUrl(response.url);
  //       // setSrcUrl(
  //       //   response.url.replace(
  //       //     'http://localhost:3000',
  //       //     'https://web.dit.healthpoint.ecocare.health'
  //       //   )
  //       // );
  //     });
  //   }
  // }, [attachmentUrl]);

  React.useEffect(() => {
    if (selectedFrame === index) {
      setSelectedUrl(mainHostUrl(attachmentUrl));
    }
  }, [selectedFrame]);

  return (
    <img
      key={index}
      className={`${classes.smallFrame} ${selectedFrame === index ? classes.selectedFrame : ''}`}
      onClick={() => setSelectedFrame()}
      src={mainHostUrl(attachmentUrl)}
      alt={attachmentUrl}
    />
  );
};

export { FramesListItem };
